class DeviceColorSwitcher {
  constructor() {
    this.colorButtons = document.querySelectorAll(".device-color__item");
    this.init();
  }

  init() {
    this.colorButtons.forEach(button => {
      button.addEventListener("click", (e) => {
        this.handleColorClick(e.currentTarget);
      });
    });
  }


  handleColorClick(button) {
  // Remove active from all
    this.colorButtons.forEach(btn => {
        btn.classList.remove("active");
    });

    // Add active to clicked
    button.classList.add("active");

    const colorName = button
        .querySelector(".visually-hidden")
        .textContent.trim();

    const newColor = colorName + "17";

    this.updateMainGallery(newColor);
    this.updateFirstThumbnail(newColor);
    this.goToFirstSlide();

    console.log("Updated to:", newColor);
    }


  /* ===============================
    GO TO FIRST SLIDE ⭐ NEW
  =============================== */

  goToFirstSlide() {
    const firstThumb = document.querySelector(
      '.slideshow-controls__thumbnails button:not(.hidden)'
    );

    if (firstThumb) {
      firstThumb.click();
    }
  }
  /* ===============================
     UPDATE FIRST MAIN IMAGE
  =============================== */
  updateMainGallery(newColor) {

  const media = document.querySelector(
    "slideshow-slide .product-media"
  );

  if (!media) return;

  const img = media.querySelector("img");
  if (!img) return;

  const updatedSrc = img.src.replace(
    /_(.*?)17/,
    `_${newColor}`
  );

  img.src = updatedSrc;

  if (img.srcset) {
    img.srcset = img.srcset.replace(
      /_(.*?)17/g,
      `_${newColor}`
    );
  }

}


  /* ===============================
     UPDATE ONLY FIRST THUMBNAIL
  =============================== */
  updateFirstThumbnail(newColor) {
    const firstThumb = document.querySelector(
      ".slideshow-controls__thumbnail img"
    );

    if (!firstThumb) return;

    const updatedSrc = firstThumb.src.replace(
      /_(.*?)17/,
      `_${newColor}`
    );

    firstThumb.src = updatedSrc;

    if (firstThumb.srcset) {
      firstThumb.srcset = firstThumb.srcset.replace(
        /_(.*?)17/g,
        `_${newColor}`
      );
    }
  }
}

// Run it
new DeviceColorSwitcher();
